import { cn } from "@/lib/utils";

type MarkProps = { className?: string; title?: string };

/**
 * Tilt.University mark — an abstract "tilted perspective" glyph shared
 * across every Tilt.University product (SmartEssay.ai, Smart-Reader.ai,
 * SmartTeacher.ai). Uses currentColor so it inherits from text-* utilities.
 */
export function TiltMark({ className, title = "Tilt.University" }: MarkProps) {
  return (
    <svg
      viewBox="0 0 40 40"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label={title}
      className={cn("text-primary", className)}
    >
      <rect x="1.5" y="1.5" width="37" height="37" rx="9" fill="currentColor" />
      <g stroke="var(--color-background)" strokeWidth="2.75" strokeLinecap="round" fill="none">
        <path d="M9 27 L23 27" opacity="0.55" />
        <path d="M11 30 L27 12" />
        <circle cx="28.5" cy="11" r="1.9" fill="var(--color-secondary-accent)" stroke="none" />
      </g>
    </svg>
  );
}

export function TiltWordmark({ className }: { className?: string }) {
  return (
    <span className={cn("text-lg font-bold tracking-tight text-foreground", className)}>
      Tilt<span className="text-secondary-accent">.</span>University
    </span>
  );
}

export function SmartEssayWordmark({ className }: { className?: string }) {
  return (
    <span className={cn("text-lg font-bold tracking-tight", className)}>
      <span className="text-essay">SmartEssay</span>
      <span className="text-muted-foreground">.ai</span>
    </span>
  );
}

export function SmartReaderWordmark({ className }: { className?: string }) {
  return (
    <span className={cn("text-lg font-bold tracking-tight", className)}>
      <span className="text-reader">Smart-Reader</span>
      <span className="text-muted-foreground">.ai</span>
    </span>
  );
}

export function SmartTeacherWordmark({ className }: { className?: string }) {
  return (
    <span className={cn("text-lg font-bold tracking-tight", className)}>
      <span className="text-teacher">SmartTeacher</span>
      <span className="text-muted-foreground">.AI</span>
    </span>
  );
}
